export default __webpack_public_path__ + "static/media/Immemorial Chain.83920453.jpg";